
(function waitForGoogle() {
  var intervalId = setInterval(function() {
    if (typeof google !== 'undefined' && google.maps) {
      clearInterval(intervalId);
      if(localStorage.getItem('nearestStores')) {
        $('.dummy_location .dummy--geocode').val(localStorage.getItem('geoCode'))
        $('#panel .dummy_storelist').append(localStorage.getItem('nearestStores'))
        $('#panel').addClass('storelocator-panel')
        $('#panel .dummy_storelist').show()
        $('.dummy_location').show()
      } else {
        var map = new google.maps.Map(document.getElementById('map-canvas'), {
          center: new google.maps.LatLng(-16.9324456, 145.7607231),
          zoom: 10,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        
        var data = new DaiwaDataSource;
        if(localStorage.getItem('map_details')) {
          var view = JSON.parse(localStorage.getItem('map_details'))
        } else { 
          var view = new storeLocator.View(map, data, {
            geolocation: true,
            features: data.getFeatures()
          });
        }

        var panelDiv = document.getElementById('panel');
        var mainPanel = new storeLocator.Panel(panelDiv, {
          view: view,
          directions: false
        });
      }

      // Add click event listener to elements with class .button_action
      var buttons = document.querySelectorAll('.button_action');
      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          
          if(localStorage.getItem('nearestStores')) {
            $('.storelocator-filter').remove()
            $('.store-list').remove()

            $('#panel .dummy_storelist').html('')
            $('.dummy_location .dummy--geocode').val('')

            $('#panel .dummy_storelist').hide()
            $('.dummy_location').hide()
            
            var map = new google.maps.Map(document.getElementById('map-canvas'), {
              center: new google.maps.LatLng(-16.9324456, 145.7607231),
              zoom: 10,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            
            var data = new DaiwaDataSource;
            if(localStorage.getItem('map_details')) {
              var view = JSON.parse(localStorage.getItem('map_details'))
            } else { 
              var view = new storeLocator.View(map, data, {
                geolocation: true,
                features: data.getFeatures()
              });
            }

            var panelDiv = document.getElementById('panel');
            var mainPanel = new storeLocator.Panel(panelDiv, {
              view: view,
              directions: false
            });

           setTimeout(() => {
             var input = document.querySelector('.pac-target-input');
              if (input) {
                input.value = '';
                input.focus();
              }
           }, 300);

          } else {
            var input = document.querySelector('.pac-target-input');
            if (input) {
              input.value = '';
              input.focus();
            }
          }

        });
      });
    }
  }, 100);
})();
